import { map, sumBy, padStart } from 'lodash'
import Decorator from './decorator'
import CreditNoteItemDecorator from 'decorators/credit-note-item'
import moment from 'moment'
import accounting from 'accounting'

export default class CreditNoteDecorator extends Decorator {
  date () {
    return moment(this.decorated.created_at, 'YYYY-MM-DD HH:ii:ss').format('MM/DD/YYYY')
  }

  total () {
    return accounting.formatMoney(sumBy(this.decorated.items, item => item.amount))
  }

  code () {
    return padStart(this.decorated.id, 5, 0)
  }

  itemsDecorated () {
    return map(this.decorated.items, item => new CreditNoteItemDecorator(item))
  }
}



// WEBPACK FOOTER //
// ./src/decorators/credit-note.js